<template>
    <component
        :is="tag"
        class="
            w-full relative flex items-center justify-between px-4 py-2 border-gray-200 whitespace-no-wrap text-gray-700
            transition duration-300
            hover:bg-gray-100
            focus:bg-gray-50
        "
        :class="{
            'cursor-pointer': !disabled,
            'border-b': dividedBottom,
            'border-t': dividedTop,
        }"
        :disabled="disabled"
        tag="a"
        :to="to"
        v-on="$listeners"
    >
        <div class="flex items-center">
            <nio-icon :name="icon" v-if="icon" />
            <span :class="{ 'ml-3': icon, 'font-semibold': selected }">
                <slot />
            </span>
        </div>
        <nio-icon class="text-xs text-blue-500" name="bold/check-1" v-if="selected" />
    </component>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            selected: {
                type: Boolean,
                default: false,
            },
            dividedBottom: {
                type: Boolean,
                default: false,
            },
            dividedTop: {
                type: Boolean,
                default: false,
            },
            tag: {
                type: String,
                default: 'button',
            },
            to: {
                type: null,
                default: null,
            },
            icon: {
                type: String,
                default: '',
            },
        },
    };
</script>
